import { FC } from 'react';

import { defectIsBinnenPeriodeNietInzetbaar, defectTypeNietInzetbaar } from '@/domain/defecten/defect';
import { Defect } from '@/types/Defecten';
import { dateWithDayOfWeekWithTime, dayOfWeekWithTime } from '@/utils/dateUtils';

import DefectIcon from './DefectIcon';

import plankStyles from '../../PlankView.module.css';
import defectStyles from './Defect.module.css';

/** Renders a single list row for Conflict, Defect and related types.
 *
 * @param props
 * @returns
 */
const DefectSidepanelListItem: FC<{ defect: Defect }> = ({ defect }) => {
  return (
    <div className={defectStyles.defectSPListItemDiv}>
      <div className={defectStyles.defectSPListItemToelichting}>
        <DefectIcon defectSoort={defectTypeNietInzetbaar(defect) ? 'DEFECT_NIET_INZETBAAR' : defect.soort} />
        <div className={plankStyles.toelichtingStyle}>{defect.toelichting}</div>
        {defectIsBinnenPeriodeNietInzetbaar(defect) && <DefectIcon.Zandloper />}
      </div>
      <div className={defectStyles.herstellenVoor}>{dateWithDayOfWeekWithTime(defect.nietMeerInzetbaarVanaf)}</div>
      <div className={defectStyles.defectSPListItemMelding}>{dayOfWeekWithTime(new Date(defect.beginTijd ?? ''))}</div>
    </div>
  );
};
export default DefectSidepanelListItem;
